import script from "./Thank.vue?vue&type=script&setup=true&lang=js"
export * from "./Thank.vue?vue&type=script&setup=true&lang=js"

import "./Thank.vue?vue&type=style&index=0&id=61e9d0da&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e9d0da"]])

export default __exports__